import { useCallback, useEffect } from 'react';
import { prop } from 'ramda';
import { useAppSelector } from '@core/js/store/hooks';

/**
 * Event fires when Server Socket disconnected.
 * @memberOf Playtech.API.events
 * @event server-socket-disconnect
 * @example Playtech.on('server-socket-disconnect', () => {
 *     // ...
 * });
 */
export const EVENT_SERVER_SOCKET_DISCONNECT = 'server-socket-disconnect';

export const useOnSocketDisconnect = (eventTarget: EventTarget) => {
    const isReconnectVisible = useAppSelector(prop('isReconnectVisible'));

    const handleEvent = useCallback(() => {
        if (!eventTarget) {
            return;
        }

        const event = new CustomEvent(EVENT_SERVER_SOCKET_DISCONNECT);
        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        if (isReconnectVisible && eventTarget) {
            handleEvent();
        }
    }, [handleEvent, isReconnectVisible, eventTarget]);
};
